import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import axios from "axios";
import { BASE_URL } from "@/config";
import { PartnerData } from "@/interface/entityInterface";

const partnerCache = new Map<number, any>();

const CommissionPartnerCell = ({ partners, partnerId }: { partners: PartnerData[], partnerId: number }) => {
    const [partner, setPartner] = useState<any>(partnerCache.get(partnerId) || null);

    useEffect(() => {

        let isMounted = true;

        const fetchPartner = async () => {

            if (partnerCache.has(partnerId)) {
                setPartner(partnerCache.get(partnerId));
                return;
            }

            try {
                const matched = partners.find((agent: PartnerData) => agent.id === partnerId);
                if (matched) {
                    partnerCache.set(partnerId, matched);
                    if (isMounted) setPartner(matched);
                }
            } catch (error) {
                console.error("Error fetching partner:", error);
            }
        };

        fetchPartner();

        return () => {
            isMounted = false;
        };

    }, [partnerId]);

    if (!partner) return "Website Client";

    return (
        <div className="w-32">
            <Badge variant="outline" className="px-1.5 text-muted-foreground capitalize">
                {partner.name}
            </Badge>
        </div>
    );

};

export default CommissionPartnerCell;
